

























import { Vue, Component, Prop } from 'vue-property-decorator';
import {namespace} from "vuex-class";


const userDataModule = namespace('userData');

@Component({
  name: 'CopyClickWrapper',
  components: {
  },
})
export default class CopyClickWrapper extends Vue {
  @Prop({ default: '' })
  private elementToCopy!: string;

  @Prop({ default: false })
  private showClipboard!: boolean;

  private isCopied: boolean = false;

  private copyElement() {
    const myHtmlCode: HTMLInputElement = this.$refs.code as HTMLInputElement;
    myHtmlCode.select();
    document.execCommand('copy');
    this.isCopied = true;

    setTimeout(() => this.isCopied = false, 1000);
  }
}
